export default "__VITE_ASSET__0WqkMTzN__"